<div class="graph-test-page">
  <header class="graph-test-header">
    <h1>Azure Communication Services — email test</h1>
    <p class="hint">
      Dev only. Sends via
      <code>POST api/v1/auth/identity/test/acs-email</code> using
      <code>ACS_CONNECTION_STRING</code> and
      <code>ACS_SENDER_ADDRESS</code> on the Accounts API (.env).
    </p>
  </header>

  <div class="actions">
    <a routerLink="/login" class="link">Back to sign-in</a>
    <a routerLink="/test/graph-user" class="link">Graph user test</a>
  </div>

  <section class="panel">
    <h2>Send test email</h2>
    <label class="field-label" for="toEmail">To</label>
    <input
      id="toEmail"
      class="email-input"
      type="email"
      [(ngModel)]="toEmail"
      placeholder="you@example.com"
      autocomplete="off"
    />

    <label class="field-label" for="subject">Subject</label>
    <input
      id="subject"
      class="email-input"
      type="text"
      [(ngModel)]="subject"
      autocomplete="off"
    />

    <label class="field-label" for="plainText">Plain text body</label>
    <textarea
      id="plainText"
      class="body-input"
      rows="4"
      [(ngModel)]="plainText"
    ></textarea>

    <div class="patch-actions">
      <button type="button" class="primary" [disabled]="!canSend" (click)="sendTestEmail()">
        {{ sending ? 'Sending…' : 'Send ACS email' }}
      </button>
    </div>

    <p class="error" *ngIf="error">{{ error }}</p>

    <div *ngIf="responseJson">
      <h3 class="subhead">Response</h3>
      <pre>{{ responseJson }}</pre>
    </div>
  </section>

  <section class="panel">
    <h2>CLI (no UI)</h2>
    <p class="hint">
      From <code>as-account-v2</code>:
      <code>npm run test:acs-email -- you@example.com</code>
    </p>
  </section>
</div>
